import React from 'react'
import Button from 'shared/ui/Button/Button'
import {
	formatActionItemCount,
	formatSessionNoteDate,
	formatSessionNoteDuration,
} from '../utils/formatSessionNoteMeta'
import { ReactComponent as MicIcon } from 'assets/icons/mic.svg'
import { ReactComponent as CalendarIcon } from 'assets/icons/calendar.svg'
import { ReactComponent as ClockIcon } from 'assets/icons/clock.svg'
import { ReactComponent as ActionIcon } from 'assets/icons/people.svg'
import { ReactComponent as OpenIcon } from 'assets/icons/arrow_square.svg'
import { ReactComponent as DeleteIcon } from 'assets/icons/trash-2.svg'
import s from '../styles/NoteCard.module.scss'

const NoteCard = ({ note, onOpen, onDelete }) => {
	const title = note?.title?.trim() || 'Untitled session'
	const summary = note?.summary?.trim() || 'No summary yet.'

	return (
		<article className={s.card}>
			<div className={s.cardIcon} aria-hidden="true">
				<span className={s.cardIconWrap}>
					<MicIcon />
				</span>
			</div>

			<div className={s.body}>
				<h3 className={s.title}>{title}</h3>

				<div className={s.meta}>
					<span className={s.meta__item}>
						<span className={s.meta__icon}>
							<CalendarIcon />
						</span>
						<span className={s.meta__text}>
							{formatSessionNoteDate(note?.createdAt)}
						</span>
					</span>
					<span className={s.meta__dot} aria-hidden="true" />
					<span className={s.meta__item}>
						<span className={s.meta__icon}>
							<ClockIcon />
						</span>
						<span className={s.meta__text}>
							{formatSessionNoteDuration(note?.durationMs)}
						</span>
					</span>
					<span className={s.meta__dot} aria-hidden="true" />
					<span className={s.meta__item}>
						<span className={s.meta__icon}>
							<ActionIcon />
						</span>
						<span className={s.meta__text}>
							{formatActionItemCount(note?.actionItemCount)}
						</span>
					</span>
				</div>

				<p className={s.summary}>{summary}</p>

				<div className={s.footer}>
					<Button
						variant="white"
						size="sm"
						onClick={() => onOpen?.(note)}
						rightIcon={
							<span className={s.openIcon}>
								<OpenIcon />
							</span>
						}
					>
						Open
					</Button>
					<button
						type="button"
						className={s.deleteButton}
						aria-label="Delete session note"
						onClick={() => onDelete?.(note)}
					>
						<span className={s.deleteButton__icon}>
							<DeleteIcon />
						</span>
					</button>
				</div>
			</div>
		</article>
	)
}

export default NoteCard
